export const TYPE_OF_SUBJECT_LIST_LOAD = "TYPE_OF_SUBJECT_LIST_LOAD"; 
